"use client";
import { useSearchParams } from "next/navigation";
import React, { Fragment, JSX, useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { FaTimes } from "react-icons/fa";
import ButtonLoader from "./ButtonLoader";

const Modal = (params: {
  children: JSX.Element;
  id: string;
  containerClassname?: string;
  boxClassname?: string;
  contentClassname?: string;
  onClose?: () => void;
  active?: boolean;
  title?: string | JSX.Element;
  large?: boolean;
  isLoading?: boolean;
  actionTemplate?: JSX.Element | null;
}) => {
  const [checked, setChecked] = useState(params.active);

  useEffect(() => {
    setChecked(params.active);
  }, [params.active]);

  return (
    <Fragment>
      <input
        type="checkbox"
        id={params.id}
        checked={checked}
        onChange={(e) => setChecked(e.target?.checked)}
        className="modal-toggle"
      />
      <AnimatePresence>
        <motion.div
          className={`modal !z-[100000000000] ${params.containerClassname} `}
          role="dialog"
        >
          <AnimatePresence>
            <motion.div
              className={`relative !z-[100000] modal-box !p-0 !bg-white ${
                params.large ? "w-11/12 max-w-5xl lg:!max-h-[90vh]" : ""
              } max-lg:!w-full flex flex-col max-lg:rounded-none ${
                params.boxClassname
              }`}
              style={{ maxHeight: "100dvh" }}
            >
              {params.title ? (
                <div className="border-b border-b-accent w-full">
                  <h2 className={`p-4 text-lg font-bold text-primary `}>
                    {params.title}
                  </h2>
                  <hr />
                </div>
              ) : null}
              <div
                className={`p-4 flex-1 overflow-y-auto flex items-start justify-start ${params.contentClassname}`}
              >
                {params.isLoading ? (
                  <span className="m-auto">
                    <ButtonLoader />
                  </span>
                ) : (
                  params.children
                )}
              </div>
              {params.actionTemplate && (
                <div className="modal-action px-4 pb-4">
                  {params.actionTemplate}
                </div>
              )}
              <label
                htmlFor={params.id}
                onClick={params.onClose!}
                className="hover:opacity-50 btn btn-ghost btn-circle transition-all cursor-pointer absolute top-2 right-2"
              >
                <FaTimes />
              </label>
            </motion.div>
          </AnimatePresence>
        </motion.div>
      </AnimatePresence>
    </Fragment>
  );
};

export default Modal;
